import { User } from "../../../models/user.model";

export class RekbotNote {
    title!: string;
    note!: string;
    note_type!: string;
    rekbot_id!: number;
    created_at!: string;
    created_by!: number;
    creator!: User;
    id?: number;
    attachment?: any;
    attachment_url?: string;
    delete_approved_by?: number;
    delete_approver?: User;
    delete_reason?: string;
    delete_requested_at?: string;
    deleted_at?: string;
    edited_by?: number;
    editor?: User;
    last_edited_at?: string;
    updated_at?: string;

    constructor(
        title: string,
        note: string,
        note_type: string,
        attachment?: any
    ) {
        this.title = title;
        this.note = note;
        this.note_type = note_type;
        this.attachment = attachment;
    }
}